export enum CartItemType {
    Service = 1,
    MaintenanceMenu,
    XtimeService,
    XtimeMenu,
    RNDService,
}

/**
 * A single item displayed in the cart overlay.
 */
export interface CartItem {
    serviceId?: number;
    name: string;
    price?: number | JSX.Element;
    minEstCost?: number;
    type: CartItemType;
    scheduleOption?: string;
    xtimeType?: 'standard' | 'menu';
    opCode?: string;
}

/**
 * Props for the Cart header sub-component.
 */
export interface CartProps {
    /*
     * Items to display in the cart list.
     */
    items: CartItem[];
    /*
     * Whether the cart overlay is visible.
     */
    visible?: boolean;
    /*
     * Called when the cart overlay is dismissed.
     */
    onClose: () => void;
}
